import { render } from "./MessageInput.vue?vue&type=template&id=46ad2ac4&scoped=true"
import script from "./MessageInput.vue?vue&type=script&lang=js"
export * from "./MessageInput.vue?vue&type=script&lang=js"

import "./MessageInput.vue?vue&type=style&index=0&id=46ad2ac4&scoped=true&lang=css"
import "./MessageInput.vue?vue&type=style&index=1&id=46ad2ac4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46ad2ac4"]])

export default __exports__